module.exports = __webpack_public_path__ + "img/undraw_monitor.140e38d1.svg";